import { useEffect, useRef, EffectCallback } from "react";

// StrictMode の開発時二重マウント (mount→unmount→mount) でも、渡した処理を1度だけ実行する
export const useMountOnce = (effect: EffectCallback) => {
  const hasRun = useRef(false);
  const isMounted = useRef(false);
  const cleanup = useRef<ReturnType<EffectCallback>>();

  useEffect(() => {
    isMounted.current = true;
    if (!hasRun.current) {
      hasRun.current = true;
      cleanup.current = effect();
    }

    return () => {
      isMounted.current = false;

      // StrictMode の疑似アンマウント対策は開発時のみ必要。本番ビルドでは
      // StrictMode の二重マウントが発生しないため、従来通り同期実行する
      if (MODE === "production") {
        cleanup.current?.();
        return;
      }

      // StrictMode の疑似アンマウントは同じ tick 内で再度マウントされるため、
      // 本当にアンマウントされたままかどうかをマイクロタスクまで待って判定する。
      // (ここで即実行すると、疑似アンマウントで cleanup が走った直後に
      //  2回目のマウントで effect が再実行されず、後始末だけが行われてしまう)
      Promise.resolve().then(() => {
        if (isMounted.current) return;
        cleanup.current?.();
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
